import { render, staticRenderFns } from "./DialogWindow.vue?vue&type=template&id=0a1d06f3&scoped=true"
import script from "./DialogWindow.ts?vue&type=script&lang=ts&external"
export * from "./DialogWindow.ts?vue&type=script&lang=ts&external"
import style0 from "./DialogWindow.scss?vue&type=style&index=0&id=0a1d06f3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d06f3",
  null
  
)

export default component.exports